import { Calendar } from '@fullcalendar/core';
window.Calendar = Calendar;

import interactionPlugin from '@fullcalendar/interaction';
window.interactionPlugin = interactionPlugin;

import momentPlugin from '@fullcalendar/moment';
window.momentPlugin = momentPlugin;

import momentTimezonePlugin from '@fullcalendar/moment-timezone';
window.momentTimezonePlugin = momentTimezonePlugin;

import rrulePlugin from '@fullcalendar/rrule';
window.rrulePlugin = rrulePlugin;

import bootstrap5Plugin from '@fullcalendar/bootstrap5';
window.bootstrap5Plugin = bootstrap5Plugin;

import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
window.resourceTimelinePlugin = resourceTimelinePlugin;

import timeGridPlugin from '@fullcalendar/timegrid';
window.timeGridPlugin = timeGridPlugin;

import dayGridPlugin from '@fullcalendar/daygrid';
window.dayGridPlugin = dayGridPlugin;

import itLocale from '@fullcalendar/core/locales/it';
window.itLocale = itLocale;